export default __webpack_public_path__ + "static/psgCard4-4b48dbed807d1957cde4899ff07a32f4.webp";